document.addEventListener("DOMContentLoaded", (event) => {
  initSliders();
});

let openedTab = 1;
function openTab(tab) {
  if (`tab${openedTab}` !== tab) {
    document.querySelector(`#btn-${tab}`).classList.add("selected");
    document.querySelector(`#${tab}`).classList.add("selected");
    document.querySelector(`#btn-tab${openedTab}`).classList.remove("selected");
    document.querySelector(`#tab${openedTab}`).classList.remove("selected");
    openedTab = tab.slice(-1);
  }
}

function initSliders() {
  let sliders = document.querySelectorAll(".slideshow-container");
  sliders.forEach(slideshow);
}
function slideshow(slider) {
  let track = slider.querySelector(".glider-track");
  let slides = slider.querySelectorAll(".glider-slide");
  let btnPrev = slider.querySelector(".glider-prev");
  let btnNext = slider.querySelector(".glider-next");
  let dots = slider.querySelectorAll(".glider-dot");
  let slideWidth = slider.getBoundingClientRect().width;
  let active = 0;
  track.style.width = slideWidth * slides.length + "px";
  track.style.left = 0;
  btnNext.addEventListener("click", slideNext);
  btnPrev.addEventListener("click", slidePrev);
  dots.forEach((dot) => {
    dot.addEventListener("click", (event) => {
      let prev = active;
      active = parseInt(dot.dataset.index);
      slides[prev].classList.remove("active");
      dots[prev].classList.remove("active");
      slides[active].classList.add("active");
      dot.classList.add("active");
      track.style.left = track.offsetLeft + slideWidth * (prev - active) + "px";
    });
  });

  let container = slider.querySelector(".glider.draggable");
  let startX = 0;
  let endX = 0;

  container.addEventListener("pointerdown", startDrag);

  function startDrag(e) {
    startX = e.clientX;
    container.addEventListener("pointerup", stopDrag);
  }

  function stopDrag(e) {
    endX = e.clientX;
    const diffX = endX - startX;
    if (diffX > 10) {
      slidePrev();
    } else if (diffX < -10) {
      slideNext();
    }
    container.removeEventListener("pointerup", stopDrag);
  }

  function slideNext() {
    if (active < slides.length - 1) {
      track.style.left = track.offsetLeft - slideWidth + "px";
      slides[active].classList.remove("active");
      slides[active + 1].classList.add("active");
      dots[active].classList.remove("active");
      dots[active + 1].classList.add("active");
      active += 1;
    } else {
      track.style.left = 0 + "px";
      slides[active].classList.remove("active");
      slides[0].classList.add("active");
      dots[active].classList.remove("active");
      dots[0].classList.add("active");
      active = 0;
    }
  }

  function slidePrev() {
    if (active > 0) {
      track.style.left = track.offsetLeft + slideWidth + "px";
      slides[active].classList.remove("active");
      slides[active - 1].classList.add("active");
      dots[active].classList.remove("active");
      dots[active - 1].classList.add("active");
      active -= 1;
    } else {
      track.style.left = -slideWidth * (slides.length - 1) + "px";
      slides[0].classList.remove("active");
      slides[slides.length - 1].classList.add("active");
      dots[0].classList.remove("active");
      dots[slides.length - 1].classList.add("active");
      active = slides.length - 1;
    }
  }
}

// Lightbox 
document.addEventListener("DOMContentLoaded", () => {
  const lightbox = document.getElementById("lightbox");
  const track = lightbox.querySelector(".glider-track");
  const dotsContainer = lightbox.querySelector(".glider-dots");
  const closeBtn = lightbox.querySelector(".lightbox__close");

  let activeIndex = 0;
  let slides = [];

  document.addEventListener("click", (e) => {
    const img = e.target.closest(".slideshow-container .glider-slide img");
    if (!img) return;

    const slider = img.closest(".slideshow-container");
    if (!slider) return;

    slides = Array.from(slider.querySelectorAll(".glider-slide img"));
    activeIndex = slides.indexOf(img);

    openLightbox();
  });

  function openLightbox() {
    track.innerHTML = "";
    dotsContainer.innerHTML = "";

    slides.forEach((img, i) => {
      const wrapper = document.createElement("div");
      wrapper.className = "glider-slide" + (i === activeIndex ? " active" : "");
      const clone = img.cloneNode(true);
      wrapper.appendChild(clone);
      track.appendChild(wrapper);

      const dot = document.createElement("button");
      dot.className = "glider-dot" + (i === activeIndex ? " active" : "");
      dot.dataset.index = i;
      dotsContainer.appendChild(dot);
    });

    lightbox.classList.add("is-open");
    lightbox.setAttribute("aria-hidden", "false");

    slideshow(lightbox.querySelector(".slideshow-container"));

    if (activeIndex > 0) {
      const dots = lightbox.querySelectorAll(".glider-dot");
      dots[activeIndex].click();
    }
  }

  function closeLightbox() {
    lightbox.classList.remove("is-open");
    lightbox.setAttribute("aria-hidden", "true");
    track.innerHTML = "";
    dotsContainer.innerHTML = "";
  }

  closeBtn.addEventListener("click", closeLightbox);

  lightbox.addEventListener("click", (e) => {
    if (e.target === lightbox) closeLightbox();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && lightbox.classList.contains("is-open")) {
      closeLightbox();
    }
  });
});


// Sticky Menu
document.addEventListener("DOMContentLoaded", function () {
  const roomSections = document.querySelectorAll('[data-room]');
  const stickyMenu = document.querySelector(".sticky-menu");
  const stickyMenuLinks = document.querySelector(".sticky-menu .modele-wrapper");
  const stickyMenuContainer = document.querySelector(".sticky-menu-wrapper");
  const offerButton = stickyMenuLinks?.querySelector(".model-link.buton");
  const galleryButton = stickyMenuLinks?.querySelector(".model-link.galerie");

  if (!roomSections.length || !stickyMenu || !stickyMenuContainer) return;

  const alertBar = document.querySelector(".app--baralert-pro");
  let alertHeight = alertBar ? alertBar.offsetHeight : 0;

  // Create spacer to prevent layout shift
  const spacer = document.createElement("div");
  spacer.style.height = `${stickyMenu.offsetHeight}px`;
  spacer.style.display = "none";
  stickyMenuContainer.parentNode.insertBefore(spacer, stickyMenuContainer.nextSibling);

  function handleScroll() {
    const containerTop = stickyMenuContainer.getBoundingClientRect().top;

    if (containerTop <= alertHeight) {
      stickyMenu.style.position = 'fixed';
      stickyMenu.style.top = `${alertHeight}px`;
      stickyMenu.style.left = '0';
      stickyMenu.style.right = '0';
      stickyMenu.style.zIndex = '999';
      spacer.style.display = 'block';
    } else {
      stickyMenu.style.position = 'relative';
      stickyMenu.style.top = '0';
      stickyMenu.style.left = '';
      stickyMenu.style.right = '';
      stickyMenu.style.zIndex = '0';
      spacer.style.display = 'none';
    }
  }

  window.addEventListener("scroll", handleScroll);
  window.addEventListener("resize", () => {
    alertHeight = alertBar ? alertBar.offsetHeight : 0;
    spacer.style.height = `${stickyMenu.offsetHeight}px`;
    handleScroll();
  });

  const existingLinks = stickyMenuLinks.querySelectorAll(
    ".model-link:not(.buton):not(.galerie)"
  );
  existingLinks.forEach(link => link.remove());

  const insertBeforeNode = galleryButton || offerButton;

  roomSections.forEach((section, index) => {
    const roomName = section.getAttribute("data-room");
    const sectionId = section.getAttribute("id");

    if (roomName && sectionId) {
      const anchor = document.createElement("a");
      anchor.className = "model-link fade-in";
      anchor.href = `#${sectionId}`;
      anchor.style.animationDelay = `${index * 100}ms`;

      const title = document.createElement("h2");
      title.className = "type";
      title.textContent = roomName;

      anchor.appendChild(title);
      stickyMenuLinks.insertBefore(anchor, insertBeforeNode);
    }
  });

  if (galleryButton) {
    galleryButton.style.display = "block";
    galleryButton.classList.add("fade-in");
    galleryButton.style.animationDelay = `${roomSections.length * 100}ms`;
  }
  if (offerButton) {
    offerButton.style.display = "block";
    offerButton.classList.add("fade-in");
    offerButton.style.animationDelay = `${(roomSections.length + 1) * 100}ms`;
  }
});

// Add all products to cart
const addAllProductsToCart = () => {
  document.querySelectorAll(".add-all-to-cart").forEach((button) => {
    button.addEventListener("click", async (event) => {
      event.preventDefault();
      console.log(button)
      const wrapper = button.closest(".buttons-wrapper") || button.closest(".empty_cart__modal");
      const forms = wrapper.querySelectorAll("form.add-all-form");
      console.log(wrapper)
      let messageDiv = wrapper.querySelector(".add-to-cart-message");
      if (!messageDiv) {
        messageDiv = document.createElement("div");
        messageDiv.className = "add-to-cart-message";
        messageDiv.style.cssText =
          "transition: all 0.3s ease; opacity: 1; transform: scale(1);";
        wrapper.appendChild(messageDiv);
      }

      messageDiv.textContent = "Se adaugă produsele în coș...";

      const items = [];
      const seen = new Set();

      forms.forEach((form) => {
        const formData = new FormData(form);
        const id = formData.get("id");
        let quantity = parseInt(formData.get("quantity"), 10);
        if (!quantity || quantity < 1) quantity = 1;
        if (id && !seen.has(id)) {
          seen.add(id);
          items.push({ id, quantity });
        }
      });

      if (items.length > 0) {
        console.log(button.classList.contains("gallerie-buton-produs-modal"))
        try {
          if (button.classList.contains("gallerie-buton-produs-modal")) {
            console.log("Cosul a fost golit!")
            await fetch("/cart/clear.js", { method: "POST" });
          }

          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ items }),
          });

          if (!response.ok) {
            throw new Error("Failed to add items to cart");
          }

          console.log("All products added to cart:", items);
          messageDiv.textContent = "Produsele au fost adăugate!";
          setTimeout(() => {
            messageDiv.textContent = "";
            messageDiv.style.opacity = "0";
            messageDiv.style.transform = "scale(0.5)";
            window.location.href = "/cart";
          }, 2000);
        } catch (error) {
          console.error("Error adding to cart:", error);
          messageDiv.textContent = "Eroare la adăugarea în coș.";
        }
      } else {
        messageDiv.textContent = "Nu sunt produse de adăugat.";
      }
    });
  });
};

document.addEventListener("DOMContentLoaded", addAllProductsToCart);


// Add to cart and total price for the gallery
document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('#dc_galerie_produse_meta');
  if (!container) { console.warn('[add-all] container not found'); return; }

  const products = document.querySelectorAll('.product_wrapper');
  const buttonsWrapper = container.querySelector('.buttons-wrapper');
  const totalsWrap = container.querySelector('.title-price-wrapper');
  const delEl = totalsWrap?.querySelector('del');
  const priceEl = totalsWrap?.querySelector('.price');

  if (!products.length || !buttonsWrapper) return;

  function formatMoney(cents) {
    const value = Number(cents) / 100;
    const formatted = value.toLocaleString("ro-RO", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return `${formatted} lei`;
  }

  const map = {};
  products.forEach((el, idx) => {
    const id = el.dataset.id?.trim();
    const inventory = parseInt(el.dataset.inventory);
    const qty = Math.max(1, parseInt(el.dataset.quantity ?? '1', 10) || 1);
    const price = parseInt(el.dataset.new_price ?? '0', 10) || 0;
    const compare = parseInt(el.dataset.old_price ?? el.dataset.new_price ?? '0', 10) || 0;
    
    if (!id) { console.warn('[add-all] missing data-id on .product_wrapper', idx, el); return; }

    if (!map[id]) {
      map[id] = { id, qty: 0, priceTotal: 0, compareTotal: 0, inventory };
    } else {
      map[id].inventory = Math.min(map[id].inventory, inventory);
    }

    map[id].qty += qty;
    map[id].priceTotal += price * qty;
    map[id].compareTotal += compare * qty;
  });

  const items = Object.values(map);

  const totals = items.reduce((a, i) => {
    a.price += i.priceTotal;
    a.compare += i.compareTotal;
    return a;
  }, { price: 0, compare: 0 });

  function animateMoney(el, fromCents, toCents, duration = 900) {
  if (!el) return;
  if (el._raf) cancelAnimationFrame(el._raf);

  const start = performance.now();
  const delta = toCents - fromCents;
  const easeOutCubic = t => 1 - Math.pow(1 - t, 3);

  const tick = (now) => {
    const t = Math.min(1, (now - start) / duration);
    const eased = easeOutCubic(t);
    const val = Math.round(fromCents + delta * eased);
    el.textContent = formatMoney(val);

    if (t < 1) {
      el._raf = requestAnimationFrame(tick);
    } else {
      el._raf = null;
    }
  };

  el.textContent = formatMoney(0);
  el._raf = requestAnimationFrame(tick);
}

  if (priceEl) {
  animateMoney(priceEl, 0, totals.price, 900);
}

if (delEl) {
  if (totals.compare > totals.price) {
    delEl.style.display = '';
    animateMoney(delEl, 0, totals.compare, 900);
  } else {
    delEl.style.display = 'none';
  }
}

  buttonsWrapper.querySelectorAll('form.add-all-form').forEach(f => f.remove());
  const anchorBtn = buttonsWrapper.querySelector('.add-all-to-cart');

  items.forEach(({ id, qty, inventory }) => {
    const form = document.createElement('form');
    form.method = 'post';
    form.action = '/cart/add';
    form.className = 'add-all-form';
    form.style.position = "absolute";

    const finalQty = inventory < qty ? inventory : qty;
    form.innerHTML = `
      <input type="hidden" name="id" value="${id}" aria-label="Adaugă toate produsele în coș">
      <input type="hidden" name="quantity" value="${finalQty}">
    `;

    buttonsWrapper.insertBefore(form, anchorBtn);
  });

  const check = Array.from(buttonsWrapper.querySelectorAll('form.add-all-form')).map(f => {
    const fd = new FormData(f);
    return { id: fd.get('id'), quantity: fd.get('quantity') };
  });
});


// Dots hover
document.addEventListener("DOMContentLoaded", () => {
  const rooms = document.querySelectorAll(".room_section");
  const isMobile = window.matchMedia("(max-width: 767px)").matches;

  rooms.forEach(room => {
    const dots = room.querySelectorAll(".stl-allDots.dot_wrapper");
    const products = room.querySelectorAll(".product_wrapper");
    const productsWrapper = room.querySelector(".products_wrapper");

    // --- DOT → PRODUCT ---
    dots.forEach(dot => {
      const dotId = dot.dataset.id;

      dot.addEventListener("mouseenter", () => {
        products.forEach(p => p.classList.remove("active"));
        dots.forEach(d => d.classList.remove("active"));

        const targetProduct = room.querySelector(`.product_wrapper[data-id="${dotId}"]`);
        if (!targetProduct) return;

        // add actives
        targetProduct.classList.add("active");
        dot.classList.add("active");

        // scroll into view logic
        if (productsWrapper) {
          if (isMobile) {
            // horizontal scroll
            const wrapperWidth = productsWrapper.clientWidth;
            const productOffset = targetProduct.offsetLeft - productsWrapper.offsetLeft;
            const productWidth = targetProduct.clientWidth;

            let targetScroll = productOffset - (wrapperWidth / 2) + (productWidth / 2);
            const maxScroll = productsWrapper.scrollWidth - wrapperWidth;

            if (targetScroll < 0) targetScroll = 0;
            if (targetScroll > maxScroll) targetScroll = maxScroll;

            productsWrapper.scrollTo({
              left: targetScroll,
              behavior: "smooth"
            });
          } else {
            // vertical scroll
            const wrapperHeight = productsWrapper.clientHeight;
            const productOffset = targetProduct.offsetTop - productsWrapper.offsetTop;
            const productHeight = targetProduct.clientHeight;

            let targetScroll = productOffset - (wrapperHeight / 2) + (productHeight / 2);
            const maxScroll = productsWrapper.scrollHeight - wrapperHeight;

            if (targetScroll < 0) targetScroll = 0;
            if (targetScroll > maxScroll) targetScroll = maxScroll;

            productsWrapper.scrollTo({
              top: targetScroll,
              behavior: "smooth"
            });
          }
        }
      });

      dot.addEventListener("mouseleave", () => {
        products.forEach(p => p.classList.remove("active"));
        dots.forEach(d => d.classList.remove("active"));
      });
    });

    // --- PRODUCT → DOT ---
    products.forEach(product => {
      const prodId = product.dataset.id;

      product.addEventListener("mouseenter", () => {
        products.forEach(p => p.classList.remove("active"));
        dots.forEach(d => d.classList.remove("active"));

        product.classList.add("active");

        const targetDot = room.querySelector(`.stl-allDots.dot_wrapper[data-id="${prodId}"]`);
        if (targetDot) {
          targetDot.classList.add("active");
        }
      });

      product.addEventListener("mouseleave", () => {
        products.forEach(p => p.classList.remove("active"));
        dots.forEach(d => d.classList.remove("active"));
      });
    });
  });
});




